import * as Yup from 'yup';

export const schema = Yup.object().shape({
  SocialManagerChannelKey: Yup.string().required('وارد کردن کلید کانال الزامی است'),
  SocialManagerChannelName: Yup.string().required('وارد کردن نام کانال الزامی است'),
});
